import { createContext } from 'react'

export const ScrollDirectionContext = createContext<'up' | 'down' | undefined>(undefined)
